import { createDynamicSegment } from "@redotech/redo-merchant-marketing-rpc/schema/segments/create-dynamic-segment";
import { createSampledSegment } from "@redotech/redo-merchant-marketing-rpc/schema/segments/create-sampled-segment";
import { createStaticSegment } from "@redotech/redo-merchant-marketing-rpc/schema/segments/create-static-segment";
import { deleteSegment } from "@redotech/redo-merchant-marketing-rpc/schema/segments/delete-segment";
import { deleteSegments } from "@redotech/redo-merchant-marketing-rpc/schema/segments/delete-segments";
import { duplicateSegmentWithOptions } from "@redotech/redo-merchant-marketing-rpc/schema/segments/duplicate-segment-with-options";
import { fetchSegmentById } from "@redotech/redo-merchant-marketing-rpc/schema/segments/fetch-segment-by-id";
import { fetchTeamSegments } from "@redotech/redo-merchant-marketing-rpc/schema/segments/fetch-team-segments";
import { getEstimatedCampaignRecipientCount } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-estimated-campaign-recipient-count";
import { getOrCreateTexasSegmentForTeam } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-or-create-texas-segment-for-team";
import { getSegmentCollections } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-segment-collections";
import { getSegmentCount } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-segment-count";
import { getSegmentMembers } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-segment-members";
import { getSegmentProductVendors } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-segment-product-vendors";
import { getSegmentProducts } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-segment-products";
import { getShopifySegments } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-shopify-segments";
import { getTokenFieldOptions } from "@redotech/redo-merchant-marketing-rpc/schema/segments/get-token-field-options";
import { refreshSegmentCount } from "@redotech/redo-merchant-marketing-rpc/schema/segments/refresh-segment-count";
import { updateDynamicSegment } from "@redotech/redo-merchant-marketing-rpc/schema/segments/update-dynamic-segment";
import { updateStaticSegment } from "@redotech/redo-merchant-marketing-rpc/schema/segments/update-static-segment";
import type { InferRpcDefinition } from "@redotech/rpc/definition";

export const rpcDefinition = {
  createDynamicSegment,
  createSampledSegment,
  createStaticSegment,
  deleteSegment,
  deleteSegments,
  duplicateSegmentWithOptions,
  fetchSegmentById,
  fetchTeamSegments,
  getEstimatedCampaignRecipientCount,
  getOrCreateTexasSegmentForTeam,
  getSegmentCollections,
  getSegmentCount,
  getSegmentMembers,
  getSegmentProducts,
  getSegmentProductVendors,
  getShopifySegments,
  getTokenFieldOptions,
  refreshSegmentCount,
  updateDynamicSegment,
  updateStaticSegment,
};

export type RedoMerchantSegmentsRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
